import React from 'react';

import { Icon } from '@chakra-ui/react';
import {
  MdGroups,
  MdLocationOn,
  MdLocalHospital,
  MdListAlt,
  MdAssignmentInd,
  MdAssignment,
  MdPsychology,
  MdConstruction,
} from 'react-icons/md';

// Auth Imports
import SignIn from 'views/auth/signIn';
import ForgetPassword from 'views/auth/forgetPassword';
import ResetPassword from 'views/auth/resetPassword';
import Team from 'views/team';
import TeamDetails from 'views/team/teamDetails';
import Location from 'views/location';
import Role from 'views/roles';
import LocationDetails from 'views/location/locationDetails';
import Providers from 'views/providers';
import Procedures from 'views/procedures';
import ProceduresDetails from 'views/procedures/proceduresDetails';
import Status from 'views/status';
import Profile from 'views/profile';
import ChangePassword from 'components/changePassword/ChangePassword';
import ProvidersDetails from 'views/providers/providersDetails';
import Patients from 'views/patients';
import PatientDetails from 'views/patients/patientDetails';
import Services from 'views/services';
import { FaHospitalUser, FaTools } from 'react-icons/fa';
import ServicesDetails from 'views/services/servicesDetails';
import ServicesForm from 'views/services/components/ServicesForm';
import ManageCategories from 'views/services/manageCategories';
import ManageTreatmentArea from 'views/services/manageTreatmentArea';
import TreatmentAreaDetails from 'views/services/manageTreatmentArea/treatmentAreaDetails';
import TeamLogs from 'views/team/teamLogs';
import AccecptInvitation from 'views/auth/accept-invitation';
import ClinicProfile from 'views/clinic-profile/ClinicProfile';
import AIAgents from 'views/super-admin/ai-agents';
import AIAgentDetails from 'views/super-admin/ai-agents/aiAgentDetails';
import Clinic from 'views/super-admin/clinic';
import AIAgentForm from 'views/super-admin/ai-agents/components/AIAgentForm';
import Tools from 'views/super-admin/tools';

const routes = [
  {
    name: 'Team',
    layout: '/admin',
    path: '/team',
    icon: <Icon as={MdGroups} width="20px" height="20px" color="inherit" />,
    component: <Team />,

  },
  {
    name: 'Patients',
    layout: '/admin',
    path: '/patients',
    icon: (
      <Icon
        as={FaHospitalUser}
        width="20px"
        objectFit="contain"
        height="15px"
        color="inherit"
      />
    ),
    component: <Patients />,
  },
  {
    name: 'Services',
    layout: '/admin',
    path: '/services',
    icon: (
      <Icon
        as={FaTools}
        width="20px"
        objectFit="contain"
        height="15px"
        color="inherit"
      />
    ),
    component: <Services />,
  },
  {
    name: 'Locations',
    layout: '/admin',
    path: '/locations',
    icon: <Icon as={MdLocationOn} width="20px" height="20px" color="inherit" />,
    component: <Location />,
  },
  {
    name: 'Providers',
    layout: '/admin',
    path: '/providers',
    icon: (
      <Icon as={MdLocalHospital} width="20px" height="20px" color="inherit" />
    ),
    component: <Providers />,
  },
  {
    name: 'Lab Procedures',
    layout: '/admin',
    path: '/lab-procedures',
    icon: <Icon as={MdListAlt} width="20px" height="20px" color="inherit" />,
    component: <Procedures />,
  },
  {
    name: 'Roles',
    layout: '/admin',
    path: '/roles',
    icon: (
      <Icon as={MdAssignmentInd} width="20px" height="20px" color="inherit" />
    ),
    component: <Role />,
  },
  {
    name: 'Status',
    layout: '/admin',
    path: '/status',
    icon: <Icon as={MdAssignment} width="20px" height="20px" color="inherit" />,
    component: <Status />,
  },
  {
    name: 'Clinic Profile',
    layout: '/admin',
    path: '/clinic-profile',
    icon: <Icon as={MdLocalHospital} width="20px" height="20px" color="inherit" />,
    component: <ClinicProfile />,
  },
  // Auth Routes
  {
    name: 'Accecpt invitation',
    layout: '/auth',
    path: '/accept_invitation',
    component: <AccecptInvitation />,
    show: false,
  },
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    component: <SignIn />,
    show: false,
  },
  {
    name: 'Forget Password',
    layout: '/auth',
    path: '/forgot-password',
    component: <ForgetPassword />,
    show: false,
  },
  {
    name: 'Reset Password',
    layout: '/auth',
    path: '/reset-password',
    component: <ResetPassword />,
    show: false,
  },
  {
    name: 'Team Details',
    layout: '/admin',
    path: '/team/details/:id',
    component: <TeamDetails />,
    show: false,
  },
  {
    name: 'Team Logs',
    layout: '/admin',
    path: '/team/logs',
    component: <TeamLogs />,
    show: false,
  },
  {
    name: 'Patient Details',
    layout: '/admin',
    path: '/patients/details/:id',
    component: <PatientDetails />,
    show: false,
  },
  {
    name: 'Service Details',
    layout: '/admin',
    path: '/services/details/:id',
    component: <ServicesDetails />,
    show: false,
  },
  {
    name: 'Add Service',
    layout: '/admin',
    path: '/services/add-service',
    component: <ServicesForm />,
    show: false,
  },
  {
    name: 'Edit Service',
    layout: '/admin',
    path: '/services/edit-service',
    component: <ServicesForm />,
    show: false,
  },
  {
    name: 'Manage Categories',
    layout: '/admin',
    path: '/services/manage-categories',
    component: <ManageCategories />,
    show: false,
  },
  {
    name: 'Manage Treatment Area',
    layout: '/admin',
    path: '/services/manage-treatment-area/',
    component: <ManageTreatmentArea />,
    show: false,
  },
  {
    name: 'Treatment Area Details',
    layout: '/admin',
    path: '/services/manage-treatment-area/details/:id',
    component: <TreatmentAreaDetails />,
    show: false,
  },
  {
    name: 'Location Details',
    layout: '/admin',
    path: '/locations/details/:id',
    component: <LocationDetails />,
    show: false,
  },
  {
    name: 'Procedure Details',
    layout: '/admin',
    path: '/lab-procedures/details/:id',
    component: <ProceduresDetails />,
    show: false,
  },
  {
    name: 'Providers Details',
    layout: '/admin',
    path: '/providers/details/:id',
    component: <ProvidersDetails />,
    show: false,
  },
  {
    name: 'Profile',
    layout: '/admin',
    path: '/profile-settings',
    component: <Profile />,
    show: false,
  },
  {
    name: 'Change Password',
    layout: '/admin',
    path: '/account-settings',
    component: <ChangePassword />,
    show: false,
  },
];


// 🧠 Superadmin-only pages (inline components or later real imports)

const superAdminRoutes = [
  {
    name: 'AI Agents',
    layout: '/admin',
    path: '/team',
    icon: <Icon as={MdPsychology} width="20px" height="20px" color="inherit" />,
    component: <AIAgents />,
    show: false,
  },
  {
    name: 'AI Agents',
    layout: '/admin',
    path: '/ai-agents',
    icon: <Icon as={MdPsychology} width="20px" height="20px" color="inherit" />,
    component: <AIAgents />,
  },
  {
    name: 'Create New AI Assistant',
    layout: '/admin',
    path: '/ai-agents/new',
    icon: <Icon as={MdPsychology} width="20px" height="20px" color="inherit" />,
    component: <AIAgentForm />,
    show: false,
  },
  {
    name: 'Edit AI Assistant',
    layout: '/admin',
    path: '/ai-agents/edit/:assistantId',
    icon: <Icon as={MdPsychology} width="20px" height="20px" color="inherit" />,
    component: <AIAgentForm />,
    show: false,
  },
  {
    name: 'AI Agent Details',
    layout: '/admin',
    path: '/ai-agents/details/:id',
    component: <AIAgentDetails />,
    show: false,
  },
  {
    name: 'Clinics',
    layout: '/admin',
    path: '/clinics',
    icon: <Icon as={MdLocalHospital} width="20px" height="20px" color="inherit" />,
    component: <Clinic />,
  },
  {
    name: 'Clinic Details',
    layout: '/admin',
    path: '/clinics/details/:id',
    component: <AIAgentDetails />,
    show: false,
  },
  {
    name: 'Tools',
    layout: '/admin',
    path: '/tools',
    icon: <Icon as={MdConstruction} width="20px" height="20px" color="inherit" />,
    component: <Tools />,
  },
];

// 🧑‍⚖️ Check user role from localStorage
const user = JSON.parse(localStorage.getItem('user_profile'));
const userRole = user?.user_role;

// 🔀 Conditional export

const filteredRoutes =
  userRole === 'superadmin'
    ? [...superAdminRoutes, ...routes.filter(route => route.show === false)]
    : routes;

export default filteredRoutes;
